import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from 'vuex';
import SidebarItem from './SidebarItem';
import ScrollBar from '@/components/ScrollBar';
export default {
  components: {
    SidebarItem: SidebarItem,
    ScrollBar: ScrollBar
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['sidebar'])), mapState({
    permission_routers: function permission_routers(state) {
      return state.permission.routers;
    }
  })), {}, {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  })
};